// extracted by mini-css-extract-plugin
export var closeButton = "_lc-1";
export var closeX = "_lc-3";
export var container = "_lc-0";
export var image = "_lc-2";